import { Product } from '@package/core/src/cartProducts/types';
import currencyFormatting from '@package/utils/src/currencyFormatting';
import config from 'config-base';
import Link from '@base/components/src/Link';
import clsx from 'clsx';
import styles from './CartPopupList.module.css';
import { CartPopupListProps } from './types';

const CartPopUpList = ({ items, orderId, deleteItem }: CartPopupListProps) => (
  <>
    {items?.products.map((product: Product) => (
      <div
        key={`${product.id}-${product.seq}`}
        className={clsx(styles.item, config.brandCode === '2' && styles.itemAGD)}
      >
        <Link
          aria-label={product.name}
          data-sku={product.id}
          href={product.productUrl && product.name != 'Gift eCard' && !product.typeService ? product.productUrl : ''}
        >
          <div className={clsx(styles.description, config.brandCode === '2' && styles.descriptionAGD)}>
            <p className={styles.name}>{product.name}</p>
            <div className={styles.qty}>
              <span className={clsx(styles.label, config.brandCode === '2' && styles.labelAGD)}>Qty:</span>
              <span className={styles.value}>{product.quantity}</span>
            </div>
            <div className={styles.price}>
              {config.brandCode === '0' && <span className={styles.label}>Price:</span>}
              <span
                className={clsx(styles.value, {
                  [styles.priceValueAGD]: config.brandCode === '2',
                })}
              >
                {currencyFormatting(product.price)}
              </span>
            </div>
          </div>
          <img
            className={clsx(styles.image, config.brandCode === '2' && styles.imageAGD)}
            alt={product.name}
            height="150"
            width="200"
            src={product.image}
          />
        </Link>
        {product.removeAvailable && config.brandCode === '0' && (
          <span
            data-testid='remove-product'
            className={styles.remove}
            onClick={() =>
              deleteItem({
                productItemId: product.seq,
                orderId: orderId,
                product: product,
              })
            }
          ></span>
        )}
        {config.brandCode === '2' && (
          <Link showCursorPointer classes={styles.removeAGD} href={`${config.mainPyramydairUrl}/shopping-cart`}>
            edit qty
          </Link>
        )}
      </div>
    ))}
  </>
);

export default CartPopUpList;
